import React from "react";
import Navbar from './Navbar'; 
import FooterSection from './FooterSection';
import ProductPage from './ProductPage';
import PdfViewerPage from './PdfViewerPage';

import "./ProductBanner.css"; // Import custom styles
import bannerImage from "../assets/img/product_banner.png"; // Import your image path

const ProductBanner = () => {
  return (
    <>
      <Navbar />
      
      {/* Main content area with background color */}
      <main className="main-content">
        <section
          className="ProductBanner-container d-flex justify-content-center align-items-center text-center position-relative"
          style={{
            backgroundImage: `url(${bannerImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '500px',  // You can adjust the height here as needed
            color: '#fff',  // Set the text color to white for better contrast
          }}
        >
          <div className="overlay-text position-absolute top-50 start-50 translate-middle">
            <h1 className="morrestact-font text-black text-start"> Advanced Digital Infrared <br/>Thermal Imaging Solutions</h1>
            <p className="popins-font text-black text-start">
            Explore our cutting-edge thermal cameras designed for medical<br/> diagnostics, face recognition, and temperature detection.
            </p>
          </div>
        </section>
        <ProductPage />
        <PdfViewerPage />
        <FooterSection />
      </main>
    </>
  );
};

export default ProductBanner;
